import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#007bbd', // Blue
        secondary: '#2F5D72', // Teal (dark blue)
        info: '#033f60', // Deep Blue
        accent: '#578033', // Green
        warning: '#804095', // purple
        error: '#ED6024', // Orange
        dorange: '#BB492E', // and orange, but darker for white-orange contrast ratio
        gray: '#BDBDBD',
        white: '#ffffff',
        yellow: '#e6b012'
      }
    }
  }
})

Vue.prototype.$vuetify = vuetify.framework

export default vuetify
